export const APIConfigData = {
	RENDERNET_BASE_URL: process.env.REACT_APP_BASE_URL,
	PROVIDER_HEADER: 'google',

	TRANSACTION_HISTORY_PAGE_SIZE: 15,
	DEFAULT_PAGE_SIZE: 20,
	CANVAS_PAGE_SIZE: 100,
	CHARACTERS_PAGE_SIZE: 100,
	PROFILE_STUDIO_HISTORY_PAGE_SIZE: 30,
	USER_PROMPT_HISTORY_PAGE_SIZE: 100,
	STYLES_PAGE_SIZE: 100,
	HOME_PROMPTS_PAGE_SIZE: 100,
};
